var React = require('react');

function EmailInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555zM0 4.697v7.104l5.803-3.558L0 4.697zM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757zm3.436-.586L16 11.801V4.697l-5.803 3.546z"}));
}

EmailInline.defaultProps = {"width":"16","height":"16","fill":"currentColor","className":"bi bi-envelope-fill mx-1","viewBox":"0 0 16 16"};

module.exports = EmailInline;

EmailInline.default = EmailInline;
